// @ts-nocheck
import { Trans, useLingui } from "@lingui/react/macro";
import { Button, Card, Center, Group, Stack, Text } from "@mantine/core";
import { observer } from "mobx-react-lite";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { HumanVerification } from "@/components/auth/HumanVerification/HumanVerification";
import { DataColumn } from "@/components/common/ui/datadisplay/DataColumn/DataColumn";
import { afterLogin } from "@/utils/auth/afterLogin";
import { handleApiResponse } from "@/utils/common/api/handleApiResponse";
import { useValidateMagicLink } from "@/utils/hooks/api/auth/useValidateMagicLink";
import { CONSENT_BANNER_OFFSET, useConsentPending } from "@/utils/hooks/useConsentPending";
import { routesList } from "../../routesList";

export default observer(function MagicLinkView() {
	const { t } = useLingui();
	const navigate = useNavigate();
	const [URLSearchParams] = useSearchParams();
	const consentPending = useConsentPending();

	const code = URLSearchParams.get("code");

	const { trigger: validateCode } = useValidateMagicLink();

	const [isLoading, setIsLoading] = useState(true);
	const [isError, setIsError] = useState(false);
	const [attempt, setAttempt] = useState(0);

	const checkCode = async ({ code, token }) => {
		if (!code) return;

		const apiResponse = await validateCode({
			query: {
				code,
				token,
			},
		});

		handleApiResponse({
			id: "login",
			apiResponse: apiResponse,
			successTitle: t`Sesión iniciada con éxito`,
			onSuccess: async () => {
				await afterLogin();
				navigate(routesList.dashboard.path);
			},
		});

		if (apiResponse.isError) {
			setIsError(true);
			setIsLoading(false);
		}
	};

	const retry = () => {
		setIsError(false);
		setIsLoading(true);
		setAttempt((a) => a + 1); // token one-shot → widget fresco
	};

	return (
		<DataColumn>
			<Center h="100vh" pb={consentPending ? CONSENT_BANNER_OFFSET : 0}>
				{isError && (
					<Card shadow="md" padding="xl" radius="md" w={{ base: "90%", sm: 420 }}>
						<Stack align="center">
							<Text ta="center">
								<Trans>El código no es válido o ha caducado.</Trans>
							</Text>

							<Group>
								<Button
									variant="light"
									onClick={retry}
									data-testid="magiclink-button-retry"
								>
									<Trans>Reintentar</Trans>
								</Button>

								<Button
									variant="subtle"
									onClick={() => navigate(routesList.login.path)}
									data-testid="magiclink-button-back"
								>
									<Trans>Volver al login</Trans>
								</Button>
							</Group>
						</Stack>
					</Card>
				)}

				{isLoading && (
					<Stack>
						<Text ta="center">
							<Trans>Validando...</Trans>
						</Text>
						<HumanVerification
							key={attempt}
							onGetToken={(token) => checkCode({ code, token })}
						/>
					</Stack>
				)}
			</Center>
		</DataColumn>
	);
});
